import { useBulkTriggerStack } from "shared/Stack/useTriggerStack";
import useCanTriggerStack from "shared/Stack/access/useCanTriggerStack";

import { StackBulkActions } from "../types";
import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";
import { StackActionItemForBulkActions } from "./types";

const useTriggerStackBulkAction = (): StackActionItemForBulkActions => {
  const [stackTrigger] = useBulkTriggerStack();
  const canTriggerStack = useCanTriggerStack();

  return {
    key: StackBulkActions.Trigger,
    title: BULK_ACTION_NAMES[StackBulkActions.Trigger],
    resultTitle: BULK_ACTION_RESULTS_TITLE[StackBulkActions.Trigger],
    condition: (stack) => canTriggerStack(stack),
    mutation: (stack) =>
      stackTrigger({
        stack: stack.id,
        runtimeConfig: null,
      }),
  };
};

export default useTriggerStackBulkAction;
